export function toEntryData(entries) {
    return entries?.map(entry => ({
        entry,
    }))
}

export function expandCategoryPageEntries(entries) {
    return entries?.map((entry) => {
            // For category awards, the entry can be added to the list for each category
            // so we create an entry for each category where it has been added to mylist
            if(entry.hasCategoryPage) {
                return Object.values(entry.categories).map(cat => ({
                    entry: entry,
                    category: cat,
                }));
            }
            // else if not showing mylist or the entry is in non-category-specific mylist then just return it as normal
            else {
                // turn entry into an array so it's in the same shape as the return above
                return [{
                    entry: entry,
                }];
            }
        })
        .flat()
        .filter(x => x)
    ;
}

export function filterMyListEntryData(entriesData) {
    return entriesData?.filter(entryData => 
        entryData.category
            ? entryData.category.isInMyList
            : entryData.entry.isInMyList
    );
}